export const CHANGE_THEME = "CHANGE_THEME";
export const CHANGE_USER = "CHANGE_USER";
